import axios from 'axios';
import { ToastService } from './toast.service';
import { AxiosService, i18n } from '@umanforge/common';

/**
 * Affiche un message d'erreur dans un toast selon le type d'erreur Axios.
 *
 * @param error - Une erreur potentiellement levée par Axios
 */
class ErrorService {
  private toastService: ToastService;

  constructor( toastService: ToastService ) {
    this.toastService = toastService;
  }

  /**
   * Affiche une erreur Axios dans un toast.
   * Si l'erreur est une erreur HTTP (4xx/5xx), un message adapté est affiché.
   * Sinon, on affiche le message brut de l'erreur.
   *
   * @param error - Une erreur de type AxiosError
   */
  showCatchAxiosError( error: unknown ) {
    if ( axios.isAxiosError( error ) ) {
      if ( AxiosService.isHttpError( error ) ) {
        this.toastService.showError( AxiosService.getAxiosMessage( error ) );
      } else {
        this.toastService.showError( error.message );
      }
    } else {
      this.toastService.showError( i18n.t( 'common:error.unknown' ) );
    }
  }
}

export { ErrorService };


